export default class TripCollection {
    itemsToShow = 4;
    showAll = false;
    showAllTrips() {
        this.showAll = true;
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('tripCollection', () => new TripCollection());
});